// Single source of truth for the API base URL.
//
// Why this file exists: REACT_APP_URL_DEV is "http://localhost:8000" for local
// development, but a browser running on ANY other machine resolves "localhost"
// to itself, so every call (login included) dies with "Failed to fetch" and the
// operator sees "Algo ocurrio al momento de eliminar la sesión...". Measured on
// 2026-10-12 against http://192.168.1.101:3003 with window.fetch instrumented.
//
// Rule:
//   1. production build  -> REACT_APP_URL_PROD, untouched.
//   2. development build -> REACT_APP_URL_DEV. If that URL points at
//      localhost/127.0.0.1/::1 and this app was NOT served from that same host,
//      the host that served the app is reused and the configured port is kept
//      (localhost:8000 served from 192.168.1.101 -> http://192.168.1.101:8000).
//   3. A configured URL that already names a real host (test/staging/prod) is
//      respected byte for byte.
//
// Do not read process.env.REACT_APP_URL_DEV anywhere else: import apiUrl() from
// this module so the base URL can never regress to the browser's localhost.
const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '0.0.0.0', '::1', '[::1]']

const isLocalHostname = hostname => LOCAL_HOSTNAMES.indexOf(hostname) !== -1

const configuredApiUrl = () =>
  process.env.REACT_APP_ENVIROMENT === 'prod' ? process.env.REACT_APP_URL_PROD : process.env.REACT_APP_URL_DEV

const withoutTrailingSlash = url => (url.endsWith('/') ? url.slice(0, -1) : url)

const apiUrl = () => {
  const configured = configuredApiUrl()

  if (!configured) return configured

  const servedFrom = typeof window !== 'undefined' ? window.location.hostname : ''
  if (!servedFrom || isLocalHostname(servedFrom)) return configured

  try {
    const parsed = new URL(configured)
    if (!isLocalHostname(parsed.hostname)) return configured

    const port = parsed.port ? `:${parsed.port}` : ''
    const path = parsed.pathname && parsed.pathname !== '/' ? parsed.pathname : ''

    return withoutTrailingSlash(`${parsed.protocol}//${servedFrom}${port}${path}`)
  } catch (error) {
    // A relative or malformed value: keep it as configured instead of guessing.
    return configured
  }
}

export default apiUrl
